import type { BusinessConfig } from "./generated/business";

function escapeVCard(value: string): string {
  return value
    .replaceAll("\\", "\\\\")
    .replaceAll(";", "\\;")
    .replaceAll(",", "\\,")
    .replaceAll("\n", "\\n");
}

export function createVCard(config: BusinessConfig): string {
  return [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `FN:${escapeVCard(config.business.name)}`,
    `ORG:${escapeVCard(config.business.name)}`,
    `TEL;TYPE=CELL:${config.contacts.whatsapp.e164}`,
    `TEL;TYPE=WORK,VOICE:${config.contacts.telephone.e164}`,
    `EMAIL;TYPE=WORK:${escapeVCard(config.contacts.email.display)}`,
    `URL:${escapeVCard(config.contacts.website.url)}`,
    `NOTE:${escapeVCard(config.coverage.summary)}`,
    "END:VCARD",
    "",
  ].join("\r\n");
}

export function downloadVCard(config: BusinessConfig): void {
  const blob = new Blob([createVCard(config)], {
    type: "text/vcard;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "greenwood-autocare.vcf";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
